import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const SortingDefaultIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 16,
  height = 16,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <path
        d="M13.0001 5.41436V12.0002H11.0001V5.41437L9.70718 6.70726L8.29297 5.29305L12.0001 1.58594L15.7072 5.29305L14.293 6.70726L13.0001 5.41436Z"
        fill="#0050B3"
        className={styles.interactiveColor}
      />
      <path
        d="M5.00007 10.5859V4.00015H3.00007V10.5859L1.70718 9.29305L0.292969 10.7073L4.00007 14.4144L7.70718 10.7073L6.29297 9.29305L5.00007 10.5859Z"
        fill="#0050B3"
        className={styles.interactiveColor}
      />
    </Icon>
  )
}
